import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import InputLimits from 'constants/InputLimits';
import getObjectValue from 'libs/getObjectValue';
import INPUT_TYPE from 'constants/INPUT_TYPE';
import {isDemandPreparing} from "libs/getDemandStatus";

const limits = InputLimits.procedure.basicInformation;

const style = theme => ({
    root: {},
    text: {
        margin: `${theme.spacing(2)}px 0`
    },
})

function ContactFields(
    {
        classes,
        formikProps,
    }) {

    const creatingDemand = getObjectValue('identity', formikProps.values, false) <= 0 || isDemandPreparing();

    return (
        <>
            <TextInput
                id={'contactPerson'}
                formikProps={formikProps}
                label={Tr('contact_person')}
                limit={limits.CONTACT_PERSON}
                multiline
                showErrorImmediately
                disabled={!creatingDemand}
            />
            <TextInput
                id={'contactPersonPhone'}
                formikProps={formikProps}
                label={Tr('contact_person_phone')}
                limit={limits.CONTACT_PERSON_PHONE}
                type={INPUT_TYPE.PHONE}
                disabled={!creatingDemand}
            />
            <TextInput
                id={'contactPersonEmail'}
                formikProps={formikProps}
                label={Tr('contact_person_email')}
                limit={limits.PURCHASER_EMAIL}
                showErrorImmediately
                disabled={!creatingDemand}
            />

            <TextInput
                id={'purchaserPhone'}
                formikProps={formikProps}
                label={Tr('purchaser_phone_number')}
                limit={limits.PURCHASER_PHONE}
                type={INPUT_TYPE.PHONE}
                disabled={!creatingDemand}
            />
            <TextInput
                id={'purchaserFax'}
                formikProps={formikProps}
                label={Tr('purchaser_fax')}
                limit={limits.PURCHASER_FAX}
                type={INPUT_TYPE.PHONE}
                disabled={!creatingDemand}
            />
            <TextInput
                id={'purchaserEmail'}
                formikProps={formikProps}
                label={Tr('purchaser_email')}
                limit={limits.PURCHASER_EMAIL}
                multiline
                showErrorImmediately
                disabled={!creatingDemand}
            />
            <TextInput
                id={'purchaserAdditionalInfo'}
                formikProps={formikProps}
                label={Tr('additional_information')}
                limit={limits.PURCHASER_ADDITIONAL_INFO}
                multiline
                disabled={!creatingDemand}
            />
        </>
    )
}

ContactFields.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(ContactFields);